// Uses the same styles as Product
import PageNav from "../components/PageNav";
import styles from "./Product.module.css";

export default function Product() {
  return (
    <main className={styles.product}>
      <PageNav />
      <section>
        <div>
          <h2>
            Simple pricing.
            <br />
            Just $9/month.
          </h2>
          <p>
           Track your travels across the globe with ease.
            For just $9/month, unlock unlimited city pins, access detailed travel logs, and visualize your adventures on a stunning world map.
            No hidden fees, cancel anytime.
          </p>
        </div>
        <img         className={styles.product_img} src="img-2.jpg" alt="overview of a large city with skyscrapers" />
      </section>
    </main>
  );
}
